import React from 'react';
import { ReactComponent as DocumentIcon } from "../../../../../../assets/img/svg/DocumentNoBackground.svg";
import AButton from '../../../common/form-fields-mui/AButton';
import styles from "./styles.module.scss"

const EmptyListPlaceholder = ({
    addConfigHandler,
    isCreatePermission,
    title = "Click here to add first EPMR configuration"
}) => {
    return (

        <div className={styles['empty-list-placeholder']}>
            <DocumentIcon />
            <h4>{title}</h4>
            <AButton
                variant="primary_filled"
                onClick={addConfigHandler}
                disabled={!isCreatePermission}
            >
                Add config
            </AButton>
        </div>

    );
}

export default EmptyListPlaceholder;